import { render, staticRenderFns } from "./DonationGroup.vue?vue&type=template&id=619f848d&"
import script from "./DonationGroup.vue?vue&type=script&lang=js&"
export * from "./DonationGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports